import React, { ForwardedRef, PropsWithChildren } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink, LinkTypeMap } from '@material-ui/core';
import { IReactProps } from 'types';

function Link(
  props: PropsWithChildren<keyof LinkTypeMap | IReactProps>,
  ref: ForwardedRef<HTMLElement>
) {
  return (
    <MuiLink color="textSecondary" component={RouterLink} underline="none" {...props} ref={ref} />
  );
}

export default React.forwardRef(Link);
